import React, { Component } from 'react';
import { connect } from 'react-redux';
import PublicationReaderStat from '../PublicationReaderStat';
import PublicationCitationStat from '../PublicationCitationStat';
import { getStats } from '../../actions/stats';

if (process.browser) require('./PublicationStats.scss');

class PublicationStatsContainer extends Component {
  componentWillMount() {
    const {
      stats,
      documentId,
      scopusDocumentId
    } = this.props;

    if (scopusDocumentId && (!stats || stats.timeout)) {
      this.props.getStats({ documentId, scopusDocumentId });
    }
  }

  render() {
    const {
      readerCount,
      stats,
    } = this.props;

    const readers = stats
      ? stats.totalReaders
      : readerCount || null;

    const citations = stats
      ? stats.totalCitations
      : null;

    return (
      <ul className="publication-stats stats-with-bullet">
        <PublicationReaderStat readerCount={readers} />
        <PublicationCitationStat citationCount={citations} />
      </ul>
    );
  }
}

const mapStateToProps = (state, props) => ({
  stats: state.stats[props.documentId],
});

const mapDispatchToProps = {
  getStats,
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicationStatsContainer);



// WEBPACK FOOTER //
// ./src/universal/ui/components/PublicationStats/PublicationStats.js